import { Location } from './Location.model';
export class Tenant {
    public readonly tenantId: string;
    public readonly tenantIdCode: string;
    public readonly tenantName: string;
    public readonly locations: Location[];

    private constructor(tenantId: string | undefined, tenantIdCode: string | undefined, tenantName: string | undefined, locations: Location[] | undefined) {
        if (tenantId === undefined) {
            throw new Error('tenantId undefined');
        }
        if (tenantIdCode === undefined) {
            throw new Error('tenantIdCode undefined');
        }
        if (tenantName === undefined) {
            throw new Error('tenantName undefined');
        }
        if (locations === undefined) {
            throw Error('locations undefined');
        }
        if (!this.areLocationIdsUnique(locations)) {
            throw Error('location with same id');
        }
        if (!this.areLocationIdCodesUnique(locations)) {
            throw Error('location with same idCode');
        }

        this.tenantId = tenantId;
        this.tenantIdCode = tenantIdCode;
        this.tenantName = tenantName;
        this.locations = locations;
    }

    public static create({
        tenantId,
        tenantIdCode,
        tenantName,
        locations,
    }: {
        tenantId: string | undefined;
        tenantIdCode: string | undefined;
        tenantName: string | undefined;
        locations: Location[] | undefined;
    }): Tenant {
        return new Tenant(tenantId, tenantIdCode, tenantName, locations);
    }

    private areLocationIdsUnique(locations: Location[]): boolean {
        const uniqueLocations = new Set(locations.map((location) => location.locationId));
        return uniqueLocations.size === locations.length;
    }

    private areLocationIdCodesUnique(locations: Location[]): boolean {
        const uniqueLocations = new Set(locations.map((location) => location.locationIdCode));
        return uniqueLocations.size === locations.length;
    }
}
